import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { SelectorService } from '@core/services';
import { isUndefined } from 'util';

import { SelectorServiceOutputModel } from '@shared/models/selector-service-output.model';

@Component({
  selector: 'app-wb-selector',
  templateUrl: './global-wb-selector.component.html'
})
export class GlobalSelectorComponent implements OnInit {

  @Input() selectorType: string | 'radio';
  @Input() inputId: string;
  @Input() labels: Array<string>;
  @Input() group: UntypedFormGroup;
  @Input() controlName: UntypedFormControl;
  @Input() toggle: boolean;
  @Input() value: number;
  @Input() valueFromOrderSummary: boolean;
  @Input() pageName: string;
  @Input() parentCompName: string;
  // Added a flag to handle Reward specific actions
  @Input() isReward: boolean;
  @Input() notRemovable: boolean;
  @Input() isMaxSelection: boolean;
  @Input() custGroupId: number;
  @Input() defaultMinValue: number;
  @Input() maxStepper: boolean;

  @Output() typeEvent: EventEmitter<any> = new EventEmitter<any>();

  // for the radio buttons
  protected valuePassed: boolean;

  // for the toggle
  protected labelPassed: boolean;

  // for the stepper counter
  protected inputLength: number;
  protected isQuantityZero: boolean;
  protected isRewardMax: boolean;

  // for stepper and slider
  protected max: number;
  protected min: number;

  // for the slider
  protected step: number;

  constructor(
    private selectorService: SelectorService
  ) {
    this.valuePassed = false;
    this.labelPassed = false;
    this.step = 1;
    this.min = 0;
    this.max = 1;
    this.inputLength = 3; // maximum input characters for the stepper if the user enters a number directly
  }

  ngOnInit() {
    if (typeof (this.labels) === 'undefined' || this.labels === null) {
      this.labels = new Array<string>();
      this.labels.push('no labels passed');
    } else {
      this.labelPassed = true;
    }
    // zero start array for slider
    if (this.defaultMinValue) {
      this.min = this.defaultMinValue;
    }
    this.max = this.labels.length - 1;
    if (typeof (this.value) === 'undefined' || this.value === null) {
      this.value = undefined;
    } else {
      this.valuePassed = true;
    }

    if (typeof (this.toggle) === 'undefined' || this.toggle === null) {
      this.toggle = false;
    }

    if (typeof (this.isReward) === 'undefined' || this.isReward === null) {
      this.isReward = false;
    }

    if (this.valueFromOrderSummary) {
      this.min = 1;
      this.max = 10000;
    }
  }

  isStepperDisabled(buttonType: string) : boolean {
    if(this.group != null) {
      if(buttonType == 'increment') {
        return this.value == this.max || this.value == undefined || this.maxStepper;
      } else if(buttonType == 'decrement') {
        return (this.value == 0 || this.value == undefined) && (this.pageName != 'orderSummary');
      }
    } else if (this.group == null) {
        if(buttonType == 'increment') {
            return this.value == this.max || this.value == undefined || this.maxStepper;
        } else if(buttonType == 'decrement') {
          return (this.value == 0 || this.value == undefined || this.value == this.min) && (this.pageName != 'orderSummary') && (this.pageName != 'editFavorite');
        }
    }
     return false;
  }
  // TODO THE GIANT STRING BEING SENT OUT SHOULD NOT BE
  // Need to create an object with named types that we can assign
  // that object gets emitted and re-casted when received through
  // a component that is subscribing to the emitevent.
  // Right now subscribed components are using magic number values to
  // parse out the giatn string being passed and this is not good programming.
  userChange(event: any, type: string) {

    const output = new SelectorServiceOutputModel();

    if (typeof (this.toggle) === 'undefined' || this.toggle === null) {
      this.toggle = !this.toggle;
    } else {
      this.toggle = this.toggle;
    }
    let message = '';
    output.labels = this.labels;
    if (this.selectorType === 'stepper') {
      if (event.currentTarget.classList.toString().indexOf('disabled') > -1) {
        return;
      }
      this.isQuantityZero = false;
      this.isRewardMax = false;

      if (this.isReward) {
        if (type === 'decrement' && this.value === 1) {
          this.isQuantityZero = true;
        }

        if (type === 'increment' && this.value === 1) {
          this.isRewardMax = true;
        }
      } else if (type === 'decrement' && this.value > this.min) {
        this.value--;
        this.typeEvent.emit(type);
      } else if (type === 'increment' && this.value < this.max) {
        this.value++;
        this.typeEvent.emit(type);
      } else if (type === 'increment' && this.value === undefined) {
        this.value = 1;
      } else if (type === 'decrement' && this.value === 1) {
        this.isQuantityZero = true;
      }
      output.labels = new Array<string>(this.labels[this.value]);

      message = this.inputId + ',' + this.labels[this.value] + ',' + this.pageName + ',' + this.isQuantityZero;
    } else if (this.selectorType === 'toggle' || this.selectorType === 'checkbox') {
      message = this.inputId + ',' + this.toggle + ',' + this.pageName;
    } else if (this.selectorType === 'slider') {
      output.labels = new Array<string>(this.labels[event.value]);
      message = this.inputId + ',' + this.labels[event.value] + ',' + this.pageName;
    } else {
      message = this.inputId + ',' + event.value + ',' + this.pageName;
    }

    output.inputId = this.inputId;

    // TODO FIX THIS WHEN REMOVING PAGENAME FROM EVERY WHERE ELSE. Use parentCompName only
    output.parentCompName = this.parentCompName ? this.parentCompName : this.pageName;
    output.isQuantityZero = this.isQuantityZero;
    output.isRewardMax = this.isRewardMax;
    output.selectorType = this.selectorType;
    output.type = type;
    output.value = this.value;
    output.custGroupId = this.custGroupId;
    output.eventValue = this.labels[this.value];
    if (this.selectorType === 'toggle' || this.selectorType === 'checkbox') {
      output.toggle = this.toggle;
    } else {
      output.toggle = undefined;
    }

    this.selectorService.sendMessage(message);
    this.selectorService.send(output);
  }
}
